import { render, staticRenderFns } from "./ReceivingCloseDetail.vue?vue&type=template&id=5c6b12a2&scoped=true"
import script from "./ReceivingCloseDetail.vue?vue&type=script&lang=js"
export * from "./ReceivingCloseDetail.vue?vue&type=script&lang=js"
import style0 from "./ReceivingCloseDetail.vue?vue&type=style&index=0&id=5c6b12a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6b12a2",
  null
  
)

export default component.exports